import $ from 'jquery';

$(document.documentElement).on("click", ".js-text-to-speech-button", function () {
    const $this = $(this);
    const message = $this.data("message");

    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = "nl-NL";

    speechSynthesis.speak(utterance);
});
